import type { ScheduleStats } from '../app/scheduleModel';
import { Icon } from '../../../../../components/ui/Icon';

interface ScheduleHeaderProps {
  date: string;
  now: Date;
  stats: ScheduleStats;
  onRefresh: () => void;
}

const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

function formatDate(dateText: string): string {
  const date = new Date(`${dateText}T00:00:00`);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}年${month}月${day}日 ${weekdays[date.getDay()]}`;
}

function formatClock(date: Date): string {
  return [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((unit) => String(unit).padStart(2, '0'))
    .join(':');
}

export function ScheduleHeader({ date, now, stats, onRefresh }: ScheduleHeaderProps) {
  return (
    <header className="schedule-header">
      <div className="schedule-date">
        <strong>{formatDate(date)}</strong>
        <span>系统时间 {formatClock(now)}</span>
      </div>
      <div className="schedule-stats" aria-label="今日课程统计">
        <span><span className="schedule-stat__label">今日课程</span> <b>{stats.total}</b></span>
        <span className="is-current"><span className="schedule-stat__label">上课中</span> <b>{stats.current}</b></span>
        <span className="is-future"><span className="schedule-stat__label">等待</span> <b>{stats.future}</b></span>
        <span><span className="schedule-stat__label">已上完</span> <b>{stats.past}</b></span>
      </div>
      <div className="schedule-refresh">
        <button type="button" className="plain-button" onClick={onRefresh}>
          <Icon name="loop-left-fill" size="sm" />
          <span>刷新</span>
        </button>
      </div>
    </header>
  );
}
